import { queryOptions } from '@tanstack/react-query';
import { Application } from 'merchant-api/types';
import { unifiedApiClient } from './client';

const getApplication = async (applicationId: string) => {
  const { data } = await unifiedApiClient.GET('/client/application/v1/{applicationId}', {
    params: { path: { applicationId } },
  });
  return data as unknown as Application;
};

export const getApplicationOpts = (applicationId: string) =>
  queryOptions<Application | null>({
    queryKey: ['app', applicationId],
    queryFn: () => getApplication(applicationId),
    enabled: !!applicationId, //don't run query if ID is missing
    refetchOnWindowFocus: false, // so query doesn't refetch
    // Keep this out of normy: AppReview polls it every 3s, and each response
    // rewriting the normalized store fans out to every query holding the application -
    // with mock fixtures that reuse one uuid across the app and its nested party, that
    // rebuild clobbers application fields (e.g. type) mid-wizard.
    meta: { normalize: false },
  });
